/**
 STORE stuff. See store/AppStore.js
 */
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {
    SET_LABELS,
    EDIT_LABELS,
    CLEAR_LABELS,
    SET_HIGHER_ORDER_LABELS,
    LABELS_PROMPT,
    LABELS_DISCARD_CHANGES,
    SET_LABELS_SAVE_HANDLER
} from '../../constants/ActionTypes';
import {
    addOnsLabels,
    searchSettings,
    filter,
    globalBar,
    guestDetails,
    general,
    hotels,
    rooms,
    confirmation,
    checkout,
    priceSummary,
    signIn,
    consolidatedLabels,
    widgets
} from '../../constants/labelsConstants';
import LabelList from '../pages/labels/LabelList';
import LabelsContainer from '../pages/labels/LabelsContainer';
import { checkPermissionForLevel, checkPermissions, httpClient } from '../../../lib/utils';
import { envValue } from '../../../config/envUtils';
import { fetchLabels } from '../helpers/fetchLabels';
import { getfilteredObject } from '../helpers/WordSearchRegexCreator';
import CTModal from '../helpers/CTModal';
import { Service } from '../../services/Service';
import { ACCESS_POINTS_GROUP, ACCESS_POINT_LEVEL } from '../../constants/AccessPoints';
import get from 'lodash/get';
import { clearSbemLabelsCache } from '../../services/BatchLabelsService';

const noop = () => {};

class ModalLabelSettings extends Component {
    constructor(props) {
        super(props);
        this.onClose = this.onClose.bind(this);
        this.save = this.save.bind(this);
        this.doFetchLabels = this.doFetchLabels.bind(this);
        this.state = {
            dummy: false,
            saving: false
        };
    }
    componentDidMount() {
        this.props.setSaveHandler(this.save);
    }
    componentWillMount() {
        this.unregisterLeaveHook = this.props.router.listenBefore(this.routerWillLeave.bind(this));
    }

    routerWillLeave(nextLocation) {
        if (this.props.changed && !this.state.saving) {
            this.props.promptUser(true);
            return false;
        }
        return true;
    }

    componentWillUnmount() {
        this.unregisterLeaveHook();
        this.props.setSaveHandler(noop);
    }

    onClose() {
        if (this.props.changed && !this.state.saving) {
            this.props.promptUser(true);
        }
        this.setState({ saving: false });
    }

    doFetchLabels() {
        fetchLabels(
            this.props.chainId,
            this.props.hotelId,
            'en-US',
            this.props.setLabels,
            this.props.setHigherOrderLabels
        );
    }

    containerRenderer(title, filterList, inContextLabelsOnly = false) {
        const { foldedValue, explicitValue } = this.props;

        return (
            <div>
                <LabelsContainer
                    heading={title}
                    languageCode={this.props.languageCode}
                    setLabels={this.props.setLabels}
                    setHigherOrderLabels={this.props.setHigherOrderLabels}
                    hotelId={this.props.hotelId}
                    chainId={this.props.chainId}
                    languageList={this.props.languageList}
                    location={this.props.location}
                    isDisabled={!this.props.permissionEdit}
                    onSave={this.save}
                    inContextBeta={this.props.inContextBeta}
                    saveButton={
                        <button
                            disabled={!this.props.changed}
                            style={{
                                maxHeight: '60px'
                            }}
                            onClick={() =>
                                this.save().then(() => {
                                    this.props.promptUser(false);
                                })
                            }
                            className="spark-btn spark-btn--md spark-btn-group-primary"
                        >
                            Save Labels
                        </button>
                    }
                >
                    <LabelList
                        foldedValue={getfilteredObject(foldedValue, filterList)}
                        explicitValue={explicitValue ? getfilteredObject(explicitValue, filterList) : null}
                        editLabels={this.props.editLabels}
                        clearLabels={this.props.clearLabels}
                        fetchLabels={this.doFetchLabels}
                        isOpened={this.props.open}
                        inContextBeta={this.props.inContextBeta}
                        isDisabled={!this.props.permissionEdit}
                        inContextLabelsOnly={inContextLabelsOnly}
                    />
                </LabelsContainer>
            </div>
        );
    }

    save(keepOpen = false) {
        const { chainId, hotelId, languageCode, explicitValue, inContextBeta } = this.props;
        const SOURCEURL = envValue('SOURCEURL');

        if (explicitValue && Object.keys(explicitValue).length === 0) {
            return Promise.resolve();
        }

        const labelPayload = {
            MetaData: {
                Comment: '',
                Name: ''
            },
            Data: {
                ...explicitValue
            }
        };
        // TODO: refactor into service
        return httpClient
            .put(
                `${SOURCEURL}/shs-bedesigner-services/v1/contents/labels?${Service.paramProxy(
                    chainId,
                    hotelId,
                    null,
                    this.props.selectedLevel
                )}&contentcode=${languageCode}`,
                labelPayload
            )
            .then(response => {
                this.setState({ saving: true });
                if (keepOpen !== true) {
                    this.onClose();
                }
                if (response.data.Result.ResultCode === 'SUCCESS') {
                    return fetchLabels(
                        chainId,
                        hotelId,
                        languageCode,
                        this.props.setLabels,
                        this.props.setHigherOrderLabels
                    ).then(response => {
                        this.props.discardChanges();
                        if (inContextBeta) {
                            clearSbemLabelsCache(chainId, hotelId, languageCode, this.props.selectedLevel);
                        }
                        return response;
                    });
                }
                return Promise.reject(response.data.Result.ResultCode);
            });
    }

    returnDisplayItem() {
        const { foldedValue } = this.props;
        const foldedValueKeys = Object.keys(foldedValue);
        let foldedValueWordList = [];
        foldedValueKeys.map(elem => {
            const wordPrefix = elem.substring(0, elem.indexOf('.') + 1);
            foldedValueWordList.push(wordPrefix);
        });
        const generalSectionWords = foldedValueWordList.filter(val => !consolidatedLabels.includes(val));
        const generalSectionWordList = generalSectionWords.filter((item, pos) => {
            return generalSectionWords.indexOf(item) == pos;
        });
        switch (this.props.component) {
            case 'signIn':
                return this.containerRenderer('Sign In Labels', signIn);
            case 'priceSummary':
                return this.containerRenderer('Price Summary Labels', priceSummary);
            case 'cart':
                return this.containerRenderer('Checkout Labels', checkout);
            case 'guestInfo':
                return this.containerRenderer('Guest Information Labels', guestDetails);
            case 'confirmation':
                return this.containerRenderer('Confirmation Labels', confirmation);
            case 'searchSettings':
                return this.containerRenderer('Search Labels', searchSettings);
            case 'globalBar':
                return this.containerRenderer('Global Bar Labels', globalBar);
            case 'filters':
                return this.containerRenderer('Filter Labels', filter);
            case 'hotel':
                return this.containerRenderer('Hotel Labels', hotels);
            case 'rooms':
                return this.containerRenderer('Room Labels', rooms);
            case 'general':
                return this.containerRenderer('General Labels', generalSectionWordList);
            case 'addOns':
                return this.containerRenderer('Add-Ons Labels', addOnsLabels);
            case 'widgets':
                return this.containerRenderer('Widgets Labels', widgets, true);
            default:
                return null;
        }
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-xs-12">{this.returnDisplayItem()}</div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <button
                            disabled={!this.props.changed}
                            onClick={() =>
                                this.save().then(() => {
                                    this.props.promptUser(false);
                                })
                            }
                            className="spark-btn spark-btn--md spark-btn-group-primary"
                        >
                            Save Labels
                        </button>
                    </div>
                </div>
                <CTModal
                    open={this.props.prompt.open}
                    primaryButtonTitle="Save"
                    secondaryButtonTitle="Discard changes"
                    secondaryButton
                    primaryButton
                    primaryButtonClick={() =>
                        this.save().then(() => {
                            this.props.promptUser(false);
                        })
                    }
                    secondaryButtonClick={() => {
                        this.props.discardChanges();
                        this.props.promptUser(false);
                    }}
                    onClose={() => {
                        this.props.discardChanges();
                        this.props.promptUser(false);
                    }}
                >
                    All unsaved changes will be lost.
                </CTModal>
            </div>
        );
    }
}

ModalLabelSettings.defaultProps = {
    prompt: {
        open: false
    },
    existingCleared: false,
    existingHidden: false,
    changed: false
};

const initialState = {
    component: 'nowhere',
    prompt: {
        open: false
    },
    existingCleared: false,
    existingHidden: false,
    changed: false
};

export const modalLabelSettingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case LABELS_PROMPT:
            return {
                ...state,
                prompt: {
                    open: action.open
                }
            };
        default:
            return state;
    }
};

/**
 /STORE stuff. See store/AppStore.js
 */

const mapStateToProps = state => ({
    open: state.app.modal.labelsInfo.isOpened,
    prompt: state.app.modal.labelsInfo.prompt,
    existingCleared: state.app.data.labels.labels.existingCleared,
    existingHidden: state.app.data.labels.labels.existingHidden,
    changed: state.app.data.labels.labels.changed,
    currentConfigCopy: state.app.data.configuration.configuration.currentConfigCopy,
    languageCode: state.app.data.labels.labels.languageCode,
    languageList: state.app.selected.languageList,
    selectedLevel: state.app.selected.level,
    chainId: state.app.selected.chain.Id,
    hotelId: state.app.selected.selectedHotel.id,
    foldedValue: state.app.data.labels.labels.foldedValueCopy,
    explicitValue: state.app.data.labels.labels.explicitValueCopy,
    inContextBeta: get(state, 'app.selected.inContextBeta'),
    permissionEdit: checkPermissionForLevel(
        state.oauth.accessLevel,
        ACCESS_POINTS_GROUP.LABELS,
        ACCESS_POINT_LEVEL.EDIT,
        state.oauth.userPermissionLevels,
        state.app.selected.level
    )
});

const mapDispatchToProps = dispatch => ({
    setSaveHandler: handler => {
        dispatch({ type: SET_LABELS_SAVE_HANDLER, handler });
    },
    setLabels: (foldedValue, explicitValue, languageCode) => {
        dispatch({ type: SET_LABELS, foldedValue, explicitValue, languageCode });
    },
    setHigherOrderLabels: foldedValue => {
        dispatch({ type: SET_HIGHER_ORDER_LABELS, foldedValue });
    },
    editLabels: (keyName, value) => {
        dispatch({ type: EDIT_LABELS, keyName, value });
    },
    promptUser: opened => {
        dispatch({ type: LABELS_PROMPT, open: opened });
    },
    discardChanges: () => {
        dispatch({ type: LABELS_DISCARD_CHANGES });
    },
    clearLabels: keyName => {
        dispatch({ type: CLEAR_LABELS, keyName });
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalLabelSettings);



// WEBPACK FOOTER //
// ./src/components/modals/ModalLabelSettings.js